import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { ReportHistoryComponent } from './report-history.component';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { FormsModule } from '@angular/forms';
import { DispatchService } from 'app/pages/dispatch/dispatch.service';
import { UsersService } from 'app/pages/users/users.service';
import { Select2Module } from '../select2/select2.module';
import { PayorsService } from 'app/pages/payors/payors.service';

@NgModule({
  imports: [
    CommonModule,
    Trip2ThemeModule,
    MyDateRangePickerModule,
    FormsModule,
    Select2Module
  ],
  declarations: [ReportHistoryComponent],
  exports: [ReportHistoryComponent],
  providers: [DispatchService, UsersService, PayorsService]
})
export class ReportHistoryModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/report-history/report-history.module.ts